import React, { useEffect } from 'react';
import { stringify, parse } from 'qs';
import { Table, Card } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';

import { useGetLogHistory } from 'redux/Hooks/user';

const UserLogHistory = ({ userId }) => {
  const history = useHistory();
  const location = useLocation();
  const { results, isFetching, totalPages, currentPage, setQuery, pageSize } = useGetLogHistory(userId);

  const parsedQuery = parse(location.search, { ignoreQueryPrefix: true });
  const [page, setPage] = React.useState(Number(parsedQuery?.logHistoryPage) - 1 || 0);

  useEffect(() => {
    setQuery({
      page,
    });
  }, [page]);

  const columns = [
    {
      title: '日付',
      dataIndex: 'updated',
      key: 'updated',
      render: (record) => <div>{moment.utc(record).local().format('YYYY/MM/DD HH:mm')}</div>,
    },
    {
      title: 'IP',
      dataIndex: 'ip',
      key: 'ip',
    },
  ];

  const handleChangePage = (pageNumber) => {
    const query = new URLSearchParams(history.location.search);
    const queryString = stringify({
      ...query,
      ...parsedQuery,
      logHistoryPage: pageNumber === 1 ? undefined : pageNumber,
    });

    setPage(pageNumber - 1);
    history.push({
      pathname: location.pathname,
      search: queryString,
    });
  };

  const pagination = {
    onChange: handleChangePage,
    current: currentPage + 1,
    pageSize,
    total: totalPages * pageSize,
    showSizeChanger: false,
    hideOnSinglePage: true,
  };

  return (
    <div className="flex flex-col my-4">
      <Card title="ログイン履歴">
        <Table
          className="bg-white overflow-x-scroll"
          rowClassName="align-top whitespace-pre-wrap break-words fixBreakWordsJapan text-center"
          components={{
            header: {
              cell: ({ className, style, ...restProps }) => {
                return <th className={className} style={{ ...style, textAlign: 'center' }} {...restProps} />;
              },
            },
          }}
          bordered
          pagination={pagination}
          dataSource={results}
          loading={isFetching}
          columns={columns}
          rowKey="id"
        />
      </Card>
    </div>
  );
};

UserLogHistory.propTypes = {
  userId: PropTypes.number,
};
export default UserLogHistory;
